import * as React from "react";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { OutskirtBuildingUpgrade } from "../outskirts/upgrade/OutskirtBuildingUpgrade";
export var UpgradeWaterTower = function (_a) {
    return React.createElement(OutskirtBuildingUpgrade, { type: IdOutskirtBuildings.Watertower });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/UpgradeWaterTower.tsx
// module id = 2807
// module chunks = 3